/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Tos_ReviewInputs */

const en_svchip_tos_review = /** @type {(inputs: Svchip_Tos_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ToS review`)
};

const ar_svchip_tos_review = /** @type {(inputs: Svchip_Tos_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مراجعة شروط الخدمة`)
};

const bn_svchip_tos_review = /** @type {(inputs: Svchip_Tos_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ToS রিভিউ`)
};

const de_svchip_tos_review = /** @type {(inputs: Svchip_Tos_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ToS-Überprüfung`)
};

const es_svchip_tos_review = /** @type {(inputs: Svchip_Tos_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisión de términos de servicio`)
};

const fr_svchip_tos_review = /** @type {(inputs: Svchip_Tos_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Examen des conditions de service`)
};

const pt_svchip_tos_review = /** @type {(inputs: Svchip_Tos_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisão dos Termos de Serviço`)
};

const zh_svchip_tos_review = /** @type {(inputs: Svchip_Tos_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`服务条款审核`)
};

const tr_svchip_tos_review = /** @type {(inputs: Svchip_Tos_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ToS review`)
};

const ru_svchip_tos_review = /** @type {(inputs: Svchip_Tos_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обзор условий обслуживания`)
};

const pl_svchip_tos_review = /** @type {(inputs: Svchip_Tos_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przegląd Warunków korzystania`)
};

/**
* | output |
* | --- |
* | "ToS review" |
*
* @param {Svchip_Tos_ReviewInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_tos_review = /** @type {((inputs?: Svchip_Tos_ReviewInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Tos_ReviewInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_tos_review(inputs)
	if (locale === "bn") return bn_svchip_tos_review(inputs)
	if (locale === "de") return de_svchip_tos_review(inputs)
	if (locale === "es") return es_svchip_tos_review(inputs)
	if (locale === "fr") return fr_svchip_tos_review(inputs)
	if (locale === "pt") return pt_svchip_tos_review(inputs)
	if (locale === "zh") return zh_svchip_tos_review(inputs)
	if (locale === "tr") return tr_svchip_tos_review(inputs)
	if (locale === "ru") return ru_svchip_tos_review(inputs)
	if (locale === "pl") return pl_svchip_tos_review(inputs)
	return en_svchip_tos_review(inputs)
});